import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import React from 'react';
import { useError } from './Provider';
/**
 * An Error _component_ for *building*
 *
 * ```ts
 * import f from './Provider'
 *
 * ```
 */

export default function Error(props) {
  var error = useError();
  return error ? /*#__PURE__*/React.createElement("pre", props, error.toString()) : null;
}